import React from 'react'
import { render } from 'react-dom'
import { HashRouter } from 'react-router-dom'
import Router from './Router'
import './style.css'

function detectOrient() {
    var width = document.documentElement.clientWidth,
      height = document.documentElement.clientHeight,
      $wrapper = document.getElementById("root"),
      style = "";
    if(window.orientation === 90 || window.orientation === -90){
    // if (width >= height) { // 横屏
      window.isRotate = true
      style += "width:" + width + "px;";
      style += "height:" + height + "px;";
      style += "-webkit-transform: rotate(0); transform: rotate(0);";
      style += "-webkit-transform-origin: 0 0;";
      style += "transform-origin: 0 0;";
    } else {              // 竖屏
      window.isRotate = false
      style += "width:" + height + "px;";
      style += "height:" + width + "px;";
      style += "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
      style += "-webkit-transform-origin: " + width / 2 + "px " + width / 2 + "px;"; // 注意旋转中点的处理
      style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    }
    window.reSizeW = height
    window.reSizeH = width
    $wrapper.style.cssText = style;
}

window.onresize = detectOrient;

detectOrient()

var overscroll = function (el) {
    el.addEventListener('touchstart', function () {
      var top = el.scrollTop, totalScroll = el.scrollHeight, currentScroll = top + el.offsetHeight;
      if (top === 0) {
        el.scrollTop = 1
      } else if (currentScroll === totalScroll) {
        el.scrollTop = top - 1
      }
    })
    el.addEventListener('touchmove', function (evt) {
      if (el.offsetHeight < el.scrollHeight) evt._isScroller = true
    })
};


document.querySelector('.main') && overscroll(document.querySelector('.main'))

document.body.addEventListener('touchmove', function (e) {
  if(e._isScroller)  return e.preventDefault();
});


render(

    <HashRouter>

        <Router/>

    </HashRouter>

,document.getElementById('root'))
